import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { BannerComponent } from '@examdojo/core/ui/banner';
import { InformativeBannerService } from './informative-banner.service';

@Component({
  selector: 'dojo-informative-banner',
  imports: [BannerComponent],
  template: `
    @if (state.bannerContent) {
      <dojo-banner [content]="state.bannerContent" [dataTest]="'banner'" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InformativeBannerComponent {
  constructor(private readonly informativeBannerService: InformativeBannerService) {}

  readonly state = connectState({
    bannerContent: this.informativeBannerService.bannerContent$,
  });
}
